import { HIGHLIGHT_SELECTION_HINT_ATTRIBUTE_NAME } from '../../types';

export const getQuerySelectorForHighlightHint = (highlightHint: string) =>
  `[${HIGHLIGHT_SELECTION_HINT_ATTRIBUTE_NAME}="${highlightHint}"]`;
